import axios from 'axios'

import { TOKEN_KEY } from 'constants/keys'
import { instalarRepeticaoDeLeitura } from './repetir-leitura'

const api = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
})

api.interceptors.request.use((config) => {
  if (!config.headers.Authorization) {
    const token = localStorage.getItem(TOKEN_KEY)
    if (token) config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

instalarRepeticaoDeLeitura(api)

export default api
